import networkTS from '@/misc/apis/networkTS'
import { RequestServiceSubmitReferenceFormPayload } from '@/types/api'
import { DigitalReferenceFormResponse } from '@/types/models'

export default {
  getReferenceForm(publicId: string): Promise<DigitalReferenceFormResponse> {
    return networkTS.requestServiceGetReferenceForm(publicId)
      .then(response => response.data as DigitalReferenceFormResponse)
  },
  submitReferenceForm(publicId: string, payload: RequestServiceSubmitReferenceFormPayload): Promise<void> {
    return networkTS.requestServiceSubmitReferenceForm(publicId, payload)
      .then(() => undefined)
  }
}
